export const permissionsKeys = {
  page: 'micro-sites.dynamic-sites.page-block', //✅
  pageBlockFind: 'micro-sites.dynamic-sites.page-block.find', //✅
  pageBlockCreate: 'micro-sites.dynamic-sites.page-block.createDefault', //✅
  pageBlockUpdate: 'micro-sites.dynamic-sites.page-block.update', //✅
  pageBlockRemove: 'micro-sites.dynamic-sites.page-block.remove', //✅
  pageBlockUpdateInactivate: 'micro-sites.dynamic-sites.inactivate.page-block.update', //✅
  pageBlockUpdateActive: 'micro-sites.dynamic-sites.active.page-block.update', //✅
  pageBlockDraft: 'micro-sites.dynamic-sites.page-block.setDraft', //✅
  pageGoToPage: 'micro-sites.dynamic-sites.page-block.goToPage', //✅
  pagePreview: 'micro-sites.dynamic-sites.page-block.preview', //✅
  pagePublish: 'micro-sites.dynamic-sites.page-block.publish', //✅
  pageChangeToPersonalizedSite: 'micro-sites.dynamic-sites.page-block.changeToPersonalizedSite', //✅
} as const;

// Permisos para editores específicos de páginas dinámicas
export const permissionsKeysPublishers = {
  page: 'editor-management',
  pageBlockFind: 'editor-management.find',
  pageBlockCreate: 'editor-management.create',
  pageBlockUpdate: 'editor-management.update',
  pageBlockRemove: 'editor-management.remove',
  pageBlockManage: 'editor-management.manage',
} as const;
